/*
* CM
* 관리 장비 시스템
* 시스템 구성
* 인터페이스 설정
*
* @since 2022-10-21
* @author wj_tams_dev01
* */

import {CmApiPrefix} from '~/utils/restApi'

const
  urlRoutingStatusPrefix = `${CmApiPrefix}/routing-status`,
  urlStaticRoutingPrefix = `${CmApiPrefix}/static-routing`,
  urlOspfRoutingPrefix = `${CmApiPrefix}/ospf`

export const state = () => ({
  deviceRoutingStatusList: [], // 라우팅 현황 리스트
  deviceStaticRoutingList: [], // 정적 라우팅 리스트
  deviceOspfConfig: { // OSPF - Config 데이터
    enable: -1,
    router_id: ''
  },
  deviceOspfAreaList: [], // OSPF - Area 리스트
  deviceOspfNetworkList: [], // OSPF - Network 리스트
  deviceOspfInterfacesList: [] // OSPF - Interface 리스트
})

export const mutations = {
  initRoutingList (state) {
    state.deviceRoutingStatusList = []
    state.deviceStaticRoutingList = []
    state.deviceOspfConfig = {
      enable: -1,
      router_id: ''
    }
    state.deviceOspfAreaList = []
    state.deviceOspfNetworkList = []
    state.deviceOspfInterfacesList = []
  },
  setRoutingStatusList (state, routingStatusList) {
    if (!_.isArray(routingStatusList)) return
    state.deviceRoutingStatusList = []
    let routingStatusData = null
    for (let i = 0; i < routingStatusList.length; i++) {
      routingStatusData = _.cloneDeep(routingStatusList[i])
      if (routingStatusData.protocol !== undefined && !_.isNumber(routingStatusData.protocol)) {
        routingStatusData.protocol = _.toNumber(routingStatusData.protocol)
      }
      if (_.isArray(routingStatusData.gw) && routingStatusData.gw.length > 0) {
        if (_.isUndefined(routingStatusData.gw[0].addr) || routingStatusData.gw[0].addr === '') { // '' 은 표시 안함
          routingStatusData.addr = null
        } else {
          routingStatusData.addr = routingStatusData.gw[0].addr
        }

        if (_.isUndefined(routingStatusData.gw[0].ifc_name)) {
          routingStatusData.ifc_name = null
        } else {
          routingStatusData.ifc_name = routingStatusData.gw[0].ifc_name
        }
        if (_.isUndefined(routingStatusData.gw[0].weight) || routingStatusData.gw[0].weight === 0) { // 0은 표시 안함
          routingStatusData.weight = null
        } else {
          routingStatusData.weight = routingStatusData.gw[0].weight
        }
        if (_.isUndefined(routingStatusData.route_type) || routingStatusData.route_type === 0 ||
            routingStatusData.route_type === 1) { // 0, 1은 표시 안함
          routingStatusData.route_type = null
        }
      }
      state.deviceRoutingStatusList.push(routingStatusData)
    }
  },
  setStaticRoutingList (state, staticRoutingList) {
    if (!_.isArray(staticRoutingList)) return
    state.deviceStaticRoutingList = []
    let staticRoutingData = null
    for (let i = 0; i < staticRoutingList.length; i++) {
      staticRoutingData = _.cloneDeep(staticRoutingList[i])
      if (_.isArray(staticRoutingData.gw) && staticRoutingData.gw.length > 0) {
        if (_.isUndefined(staticRoutingData.gw[0].addr)) {
          staticRoutingData.addr = null
        } else {
          staticRoutingData.addr = staticRoutingData.gw[0].addr
        }

        if (_.isUndefined(staticRoutingData.gw[0].ifc_name)) {
          staticRoutingData.ifc_name = null
        } else {
          staticRoutingData.ifc_name = staticRoutingData.gw[0].ifc_name
        }
        if (_.isUndefined(staticRoutingData.gw[0].weight) || staticRoutingData.gw[0].weight === 0) { // 0은 표시 안함
          staticRoutingData.weight = null
        } else {
          staticRoutingData.weight = staticRoutingData.gw[0].weight
        }
        if (_.isUndefined(staticRoutingData.gw[0].ifauto)) {
          staticRoutingData.ifauto = null
        } else {
          staticRoutingData.ifauto = staticRoutingData.gw[0].ifauto
        }
        if (_.isUndefined(staticRoutingData.gw[0].invalid)) {
          staticRoutingData.invalid = null
        } else {
          staticRoutingData.invalid = staticRoutingData.gw[0].invalid
        }
        if (_.isUndefined(staticRoutingData.route_type) || staticRoutingData.route_type === 0 ||
            staticRoutingData.route_type === 1) { // 0, 1은 표시 안함
          staticRoutingData.route_type = null
        }
        if (_.isUndefined(staticRoutingData.status_check) || staticRoutingData.status_check === 0) { // 0은 표시 안함
          staticRoutingData.status_check = null
        }
      }
      state.deviceStaticRoutingList.push(staticRoutingData)
    }
  },
  setOspfRoutingList (state, ospfRoutingList) {
    if (ospfRoutingList === undefined) {
      state.deviceOspfConfig = {
        enable: -1,
        router_id: ''
      }
      state.deviceOspfAreaList = []
      state.deviceOspfNetworkList = []
      state.deviceOspfInterfacesList = []
      return
    }
    if (ospfRoutingList.config !== undefined) {
      state.deviceOspfConfig = ospfRoutingList.config
    } else {
      state.deviceOspfConfig = {
        enable: -1,
        router_id: ''
      }
    }
    if (ospfRoutingList.areas !== undefined) {
      state.deviceOspfAreaList = ospfRoutingList.areas
    } else {
      state.deviceOspfAreaList = []
    }
    if (ospfRoutingList.networks !== undefined) {
      state.deviceOspfNetworkList = ospfRoutingList.networks
    } else {
      state.deviceOspfNetworkList = []
    }
    if (ospfRoutingList.interfaces !== undefined) {
      state.deviceOspfInterfacesList = ospfRoutingList.interfaces
    } else {
      state.deviceOspfInterfacesList = []
    }
  }
}

export const actions = {
  /* 라우팅 현황 조회 */
  async getRoutingStatusList ({commit, state}, param) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlRoutingStatusPrefix}/${param}`)
      if (code === 'ok') {
        commit('setRoutingStatusList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  /* 정적 라우팅 조회 */
  async getStaticRoutingList ({commit, state}, param) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlStaticRoutingPrefix}/${param}`)
      if (code === 'ok') {
        commit('setStaticRoutingList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  /* OSPF 라우팅 조회 */
  async getOspfRoutingList ({commit, state}, param) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlOspfRoutingPrefix}/${param}`)
      if (code === 'ok') {
        commit('setOspfRoutingList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  }
}
